import { render, staticRenderFns } from "./FormularioSubDePostulacion.vue?vue&type=template&id=436cde0d&scoped=true"
import script from "./FormularioSubDePostulacion.vue?vue&type=script&lang=js"
export * from "./FormularioSubDePostulacion.vue?vue&type=script&lang=js"
import style0 from "./FormularioSubDePostulacion.vue?vue&type=style&index=0&id=436cde0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436cde0d",
  null
  
)

export default component.exports